import template from './insuranceNoteUpdate.html';
import './style.scss';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    noteTitle: '<',
    noteContent: '<',
    close: '&',
    onSave: '&',
  },
};
